import Vue from 'vue'

/**
 * A field label above its box wraps instead of being cut with an ellipsis (sweep 2026-11-04,
 * "Number of orders employees can place…"). The label stays absolutely placed 8px above the box
 * (_fields.scss) and the field keeps 28px for one line above the box; a label that takes more lines
 * hands its height to the field (`--dd-label-space`), so the box moves down and the 8px gap holds.
 *
 * One shared ResizeObserver watches the labels of the Vuetify text fields, textareas and selects:
 * a label re-wraps when its field changes width (a dialog opening, a tab, the window), not only when
 * its text changes.
 */

const ONE_LINE = 20
const GAP = 8

let observer = null

function labelSpace(label) {
    const field = label.closest('.v-text-field')
    if (!field) return
    const height = label.offsetHeight
    if (height > ONE_LINE + 2) {
        field.style.setProperty('--dd-label-space', `${height + GAP}px`)
    } else {
        field.style.removeProperty('--dd-label-space')
    }
}

function labelObserver() {
    if (!observer && typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver((entries) => {
            entries.forEach((entry) => labelSpace(entry.target))
        })
    }
    return observer
}

function fieldLabel(vm) {
    const el = vm.$el
    if (!el || !el.classList || !el.classList.contains('v-text-field')) {
        return null
    }
    return el.querySelector(
        ':scope > .v-input__control > .v-input__slot > div > .v-label'
    )
}

function syncLabel(vm) {
    const label = fieldLabel(vm)
    if (label === vm.$_ddLabel) return
    const ro = labelObserver()
    if (!ro) return
    if (vm.$_ddLabel) ro.unobserve(vm.$_ddLabel)
    vm.$_ddLabel = label
    if (label) ro.observe(label)
}

Vue.mixin({
    mounted() {
        // the Vuetify fields that render a label above their box (VTextField and its children)
        if (!this.$options.methods || !this.$options.methods.genLabel) return
        this.$_ddLabelField = true
        syncLabel(this)
    },
    updated() {
        if (this.$_ddLabelField) syncLabel(this)
    },
    beforeDestroy() {
        if (this.$_ddLabel && observer) observer.unobserve(this.$_ddLabel)
        this.$_ddLabel = null
    },
})
